// Taking ground off the board: the Micro-Singularity Bomb and `dev-collapse`.

import { removePiece, setCells, type Position } from "./position";
import type { IndustryState } from "./industry/state";

/**
 * Take a square off the board, with everything on it.
 *
 * **By reflection over every square-keyed store**, which is the same method
 * `orphans.test.ts` uses to find them — and for the same reason: a
 * hand-written list is a thing to forget when a store is added, and an entry
 * left behind is unreachable state that is hashed forever. There are two dozen
 * of these maps and a removal can take a square holding any of them.
 *
 * A building stands on a cell (§31 S1), so it goes with its square like
 * everything else — the industry's record and the position's three mirrors.
 */
export function removeSquare(position: Position, industry: IndustryState, sq: number): void {
  // **The piece goes through `removePiece`, not through the sweep below.**
  // `board` is a Map like the rest and deleting from it directly is exactly
  // the bug that function exists to prevent: `counts` would keep counting a
  // piece that is gone and `kings` would point at an empty square, which every
  // check test reads without ever throwing — it quietly asks whether nothing
  // is attacked, and answers.
  removePiece(position, sq);

  // Everything else by reflection, which is the method `orphans.test.ts` uses
  // to *find* these and for the same reason: a hand-written list is a thing to
  // forget when a store is added, and this can remove a square holding any
  // of two dozen of them.
  for (const store of Object.values(position)) {
    if (store instanceof Map) store.delete(sq);
  }
  for (const store of Object.values(industry)) {
    if (store instanceof Map) store.delete(sq);
  }
  // The mirrors that are Sets (`cells` is the other, and goes below).
  position.obstructions.delete(sq);
  position.belts.delete(sq);
  setCells(position, position.cellList.filter((at) => at !== sq));
}
